import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
// import dynamic from '@wd/lowcode-pc/plugin/store/index.js'; 

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
    userInfo:{},
		currentRouter: '',
		commonData: {
			parent: 1,
		},
        nav: [],
		logo: '',
        theme: '',
        isNewSaas:false,//用户中心改造标识
        loginBackgroundImg: '',
        loginImg: '',
        currentLanguage:localStorage.getItem('current_language')
	},
	mutations: {
        setUserInfo(state, val){
            state.userInfo = val
            // localStorage.setItem('userInfo',JSON.stringify(val))
        },
        setSaasFlag(state, val){
            state.isNewSaas = val
        },
        setNav(state,val){
            state.nav = val
        },
        setCurrentLanguage(state, val){
            state.currentLanguage = val
        },
		setCommonData(state, val) {
			state.commonData.parent = val.parent
		},
		setLogo(state, val) {
			state.logo = val
		},
		setTheme(state, val) {
			state.theme = val
        },
        setLoginBackgroundImg(state, val){
            state.loginBackgroundImg = val
        },
        setLoginImg(state, val){
            state.loginImg = val
        }
	},
	actions: {
    logout({commit,state}){
      commit('setNav',[])
      commit('setUserInfo',{})
      const currentLanguage = localStorage.getItem('current_language')
      localStorage.clear();
      // 退出登录的时候存储一下当前语言
      localStorage.setItem('current_language',currentLanguage)
      router.push("/entrance");
    }
  },
    getters: {
      nav (state) {
        return state.nav
      },
      getLoginBackgroundImg(state){
        return state.loginBackgroundImg
      },
      getLoginImg(state){
        return state.loginImg
      },
      getLogo(state){
        return state.logo
      },
    },
    modules: {
      // dynamic
    }
})
